export default {
    'zh_CN': {
        'ipms.attendance-user.id.label': '主键ID',
        'ipms.attendance-user.id.holder': '请输入主键ID',
        
        
        'ipms.attendance-user.id.required': '主键ID必填',
        'ipms.attendance-user.userName.label': '员工姓名',
        'ipms.attendance-user.userName.holder': '请输入员工姓名',
        'ipms.attendance-user.userName.max': '员工姓名最多50个字符',
        
        'ipms.attendance-user.userName.required': '员工姓名必填',
        'ipms.attendance-user.userPost.label': '员工岗位',
        'ipms.attendance-user.userPost.holder': '请输入员工岗位',
        
        
        'ipms.attendance-user.userPost.dictionary': ()=>[{value:11,label:'日勤'},{value:12,label:'值班人员'},{value:13,label:'海关'},{value:14,label:'调度'},{value:0,label:'值班员'},{value:1,label:'叉车'},{value:2,label:'装卸工'},{value:3,label:'东门卫'},{value:4,label:'西门卫'},{value:5,label:'东南门卫'},{value:6,label:'保洁'},{value:7,label:'消控'},{value:8,label:'餐厅'},{value:9,label:'种植'},{value:10,label:'养殖'}],
        'ipms.attendance-user.userPost.required': '员工岗位必填',
        'ipms.attendance-user.userCategory.label': '员工类别',
        'ipms.attendance-user.userCategory.holder': '请输入员工类别',
        
        
        'ipms.attendance-user.userCategory.dictionary': ()=>[{value:0,label:'正式员工'},{value:1,label:'派遣员工'},{value:2,label:'外包员工'}],
        'ipms.attendance-user.userCategory.required': '员工类别必填',
        'ipms.attendance-user.attendanceGroup.label': '考勤分组',
        'ipms.attendance-user.attendanceGroup.holder': '请输入考勤分组',
        
        
        'ipms.attendance-user.attendanceGroup.dictionary': ()=>[{value:0,label:'路工'},{value:1,label:'派遣'},{value:2,label:'货四股'},{value:3,label:'物业'}],
        'ipms.attendance-user.attendanceGroup.required': '考勤分组必填',
        'ipms.attendance-user.remark.label': '备注',
        'ipms.attendance-user.remark.holder': '请输入备注',
        'ipms.attendance-user.remark.max': '备注最多500个字符',
        
        'ipms.attendance-user.remark.required': '备注必填',
        'ipms.attendance-user.status.label': '状态',
        'ipms.attendance-user.status.holder': '请输入状态',
        
        
        'ipms.attendance-user.status.dictionary': ()=>[{value:0,label:'禁用'},{value:1,label:'启用'}],
        'ipms.attendance-user.status.required': '状态必填',
        'ipms.attendance-user.createTime.label': '创建时间',
        'ipms.attendance-user.createTime.holder': '请输入创建时间',
        'ipms.attendance-user.createTime.required': '创建时间必填',
        'ipms.attendance-user.updateTime.label': '更新时间',
        'ipms.attendance-user.updateTime.holder': '请输入更新时间',
        'ipms.attendance-user.updateTime.required': '更新时间必填',
        'ipms.attendance-user.deleted.label': '是否删除',
        'ipms.attendance-user.deleted.holder': '请输入是否删除',
        'ipms.attendance-user.deleted.required': '是否删除必填'
    },
    'zh_TW': {
        'ipms.attendance-user.id.label': '主键ID',
        'ipms.attendance-user.id.holder': '請輸入主键ID',
        
        
        'ipms.attendance-user.id.required': '主键ID必填',
        'ipms.attendance-user.userName.label': '员工姓名',
        'ipms.attendance-user.userName.holder': '請輸入员工姓名',
        
        
        'ipms.attendance-user.userName.required': '员工姓名必填',
        'ipms.attendance-user.userPost.label': '员工岗位',
        'ipms.attendance-user.userPost.holder': '請輸入员工岗位',
        
        
        'ipms.attendance-user.userPost.required': '员工岗位必填',
        'ipms.attendance-user.userCategory.label': '员工类别',
        'ipms.attendance-user.userCategory.holder': '請輸入员工类别',
        
        
        'ipms.attendance-user.userCategory.required': '员工类别必填',
        'ipms.attendance-user.attendanceGroup.label': '考勤分组',
        'ipms.attendance-user.attendanceGroup.holder': '請輸入考勤分组',
        
        
        'ipms.attendance-user.attendanceGroup.required': '考勤分组必填',
        'ipms.attendance-user.remark.label': '备注',
        'ipms.attendance-user.remark.holder': '請輸入备注',
        
        
        'ipms.attendance-user.remark.required': '备注必填',
        'ipms.attendance-user.status.label': '状态',
        'ipms.attendance-user.status.holder': '請輸入状态',
        
        
        'ipms.attendance-user.status.required': '状态必填',
        'ipms.attendance-user.createTime.label': '创建时间',
        'ipms.attendance-user.createTime.holder': '請輸入创建时间',
        
        
        'ipms.attendance-user.createTime.required': '创建时间必填',
        'ipms.attendance-user.updateTime.label': '更新时间',
        'ipms.attendance-user.updateTime.holder': '請輸入更新时间',
        
        
        'ipms.attendance-user.updateTime.required': '更新时间必填',
        'ipms.attendance-user.deleted.label': '是否删除',
        'ipms.attendance-user.deleted.holder': '請輸入是否删除',
        
        
        'ipms.attendance-user.deleted.required': '是否删除必填'
    },
    'en_US': {
        'ipms.attendance-user.id.label': 'id',
        'ipms.attendance-user.id.holder': 'Enter id',
        'ipms.attendance-user.id.max': 'id max length: 主键ID',
        
        
        'ipms.attendance-user.id.required': 'id required',
        'ipms.attendance-user.userName.label': 'userName',
        'ipms.attendance-user.userName.holder': 'Enter userName',
        'ipms.attendance-user.userName.max': 'userName max length: 员工姓名',
        
        
        'ipms.attendance-user.userName.required': 'userName required',
        'ipms.attendance-user.userPost.label': 'userPost',
        'ipms.attendance-user.userPost.holder': 'Enter userPost',
        'ipms.attendance-user.userPost.max': 'userPost max length: 员工岗位',
        
        
        'ipms.attendance-user.userPost.required': 'userPost required',
        'ipms.attendance-user.userCategory.label': 'userCategory',
        'ipms.attendance-user.userCategory.holder': 'Enter userCategory',
        'ipms.attendance-user.userCategory.max': 'userCategory max length: 员工类别',
        
        
        'ipms.attendance-user.userCategory.required': 'userCategory required',
        'ipms.attendance-user.attendanceGroup.label': 'attendanceGroup',
        'ipms.attendance-user.attendanceGroup.holder': 'Enter attendanceGroup',
        'ipms.attendance-user.attendanceGroup.max': 'attendanceGroup max length: 考勤分组',
        
        
        'ipms.attendance-user.attendanceGroup.required': 'attendanceGroup required',
        'ipms.attendance-user.remark.label': 'remark',
        'ipms.attendance-user.remark.holder': 'Enter remark',
        'ipms.attendance-user.remark.max': 'remark max length: 备注',
        
        
        'ipms.attendance-user.remark.required': 'remark required',
        'ipms.attendance-user.status.label': 'status',
        'ipms.attendance-user.status.holder': 'Enter status',
        'ipms.attendance-user.status.max': 'status max length: 状态',
        
        
        'ipms.attendance-user.status.required': 'status required',
        'ipms.attendance-user.createTime.label': 'createTime',
        'ipms.attendance-user.createTime.holder': 'Enter createTime',
        'ipms.attendance-user.createTime.max': 'createTime max length: 创建时间',
        
        
        'ipms.attendance-user.createTime.required': 'createTime required',
        'ipms.attendance-user.updateTime.label': 'updateTime',
        'ipms.attendance-user.updateTime.holder': 'Enter updateTime',
        'ipms.attendance-user.updateTime.max': 'updateTime max length: 更新时间',
        
        
        'ipms.attendance-user.updateTime.required': 'updateTime required',
        'ipms.attendance-user.deleted.label': 'deleted',
        'ipms.attendance-user.deleted.holder': 'Enter deleted',
        'ipms.attendance-user.deleted.max': 'deleted max length: 是否删除',
        
        
        'ipms.attendance-user.deleted.required': 'deleted required'
    }
}
